import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import '@/assets/css/main.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios' //引用axios
import './assets/css/animate.min.css' //引用动画
import { WOW } from './assets/js/wow.min.js' //引用滚动条动画
import { mixins } from './mixin/index'
import './assets/js/NProgress' //进度条配置
import NProgress from 'nprogress'
import scroll from 'vue-seamless-scroll'
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';


const path = process.env.VUE_APP_BASE_API
//图片路径拼接,下载模板
Vue.mixin(mixins)
Vue.prototype.$EventBus = new Vue() //注册全局事件总线
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$wow = WOW
Vue.prototype.path = path
Vue.use(ElementUI)
Vue.use(scroll)
// Vue.use(BootstrapVue);
// Vue.use(IconsPlugin);
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app')
